import {
  TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL,
  COMMON_PERSONAL_DATA_PROCESSING_URL,
  CALLBACK_PERSONAL_DATA_PROCESSING_URL,
  OFFER_POLICY_URL,
  CONSENT_DISTRIBUTION_URL,
} from '@/shared/constants/urlConstants';
import type { PolicyDocumentMeta } from '@/pages/policies/model/types/policies';

export const POLICY_DOCUMENTS: PolicyDocumentMeta[] = [
  {
    id: 1,
    slug: 'privacy-policy',
    label: 'Политика конфиденциальности',
    link: PRIVACY_POLICY_URL,
    title:
      'Политика в области обработки и обеспечения защиты персональных данных - Юрик.ру',
    description:
      'Политика Юрик.ру в области обработки и обеспечения защиты персональных данных: цели и принципы обработки, права субъектов персональных данных',
  },
  {
    id: 2,
    slug: 'terms',
    label: 'Пользовательское соглашение',
    link: TERMS_OF_USE_URL,
    title: 'Пользовательское соглашение - Юрик.ру',
    description:
      'Пользовательское соглашение сервиса по подбору юристов и адвокатов Юрик.ру: условия использования сайта, права и обязанности пользователей',
  },
  {
    id: 3,
    slug: 'offer',
    label: 'Оферта для специалистов',
    link: OFFER_POLICY_URL,
    title: 'Оферта для Специалистов (лицензионный договор) - Юрик.ру',
    description:
      'Оферта для специалистов сервиса Юрик.ру (лицензионный договор): условия размещения профиля юриста, адвоката или организации',
  },
  {
    id: 4,
    slug: 'consent-form-2',
    label: 'Согласие на обработку данных заказчиков',
    link: CALLBACK_PERSONAL_DATA_PROCESSING_URL,
    title: 'Согласие на обработку персональных данных Заказчиков - Юрик.ру',
    description:
      'Форма согласия заказчиков сервиса Юрик.ру на обработку персональных данных в соответствии с законом 152-ФЗ',
  },
  {
    id: 5,
    slug: 'consent-form-1',
    label: 'Согласие на обработку данных специалистов',
    link: COMMON_PERSONAL_DATA_PROCESSING_URL,
    title: 'Согласие на обработку персональных данных Специалистов - Юрик.ру',
    description:
      'Форма согласия специалистов сервиса Юрик.ру на обработку персональных данных в соответствии с законом 152-ФЗ',
  },
  {
    id: 6,
    slug: 'consent-distribution',
    label: 'Согласие на распространение данных',
    link: CONSENT_DISTRIBUTION_URL,
    title:
      'Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения - Юрик.ру',
    description:
      'Форма согласия на обработку персональных данных, разрешённых субъектом для распространения, для публикации профиля на сервисе Юрик.ру',
  },
];

export const LEGAL_OG_TITLE =
  'Правовые документы сервиса по подбору юристов, адвокатов - Юрик.ру';

export const OFFSET_FOR_SCROLL = 300;
export const OFFSET_FOR_SCROLL_MOBILE = 400;
